import React from 'react';

interface ZoomControlsProps {
  zoomLevel: number;
  setZoomLevel: (zoomLevel: number) => void;
}

const ZoomControls: React.FC<ZoomControlsProps> = ({ zoomLevel, setZoomLevel }) => {
  const handleZoomIn = () => {
    if (zoomLevel < 150) {
      setZoomLevel(zoomLevel + 7);
    }
  };

  const handleZoomOut = () => {
    if (zoomLevel > 50) {
      setZoomLevel(zoomLevel - 7);
    }
  };

  return (
    <div className="zoom-controls position-fixed bottom-0 end-0 p-3" style={{ zIndex: 1000 }}>
      <button className="btn btn-dark rounded-circle m-1 d-flex justify-content-center align-items-center" style={{ width: '25px', height: '25px' }} onClick={handleZoomIn}>
        <span className="text-white">+</span>
      </button>
      <button className="btn btn-dark rounded-circle m-1 d-flex justify-content-center align-items-center" style={{ width: '25px', height: '25px' }} onClick={handleZoomOut}>
        <span className="text-white">-</span>
      </button>
    </div>
  );
};

export default ZoomControls;
